// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"473d966c","237":"d83a2ae1","378":"dce60651","423":"7b87cfc5","453":"ee051c4c","529":"74f98eb0","547":"63d1202c","569":"7746c6a8","673":"f06ccfc9","750":"e076e704","852":"3b767315"}[chunkId] + ".chunk.js";
};